import React, { useState } from "react";

import fallback_img from "../img/fallback_img.jpg"

import loading_img from "../img/loadingImg.jpg"
import { useDispatch } from "react-redux";
import { ChartNoAxesGantt, CopyPlus, CornerLeftDown, CornerRightUp, Edit, EllipsisVertical, EyeOff, GripVertical, Trash2, X } from "lucide-react";
import ImageWithFallback from "./ImageFallBack";
import LoadingButton from "../Loading/LoadingButton";
import Toggle from "./Toggle";


const ImagesUI = ({ images, changeImages ,sendBackArray}) => {
       const dispatch = useDispatch();  
   const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
   
const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }

      const [itemArr, setItemArr] = useState(images);
     
      const [itemTitle, setItemTitle] = useState();
      const [itemSubTitle, setItemSubTitle] = useState();
    const [itemHideImage, setItemHideImage] = useState();
     
  const [loader , setLoader] =useState({status:false});
  const [editImage , setEditImage] =useState(false);
  const [imageObject , setImageObject] =useState({});
  
     const [openFullImg, setOpenFullImg] = useState(false);
         function generateTimestamp() {
              return Math.floor(Date.now() / 1000);
            }
      
            const removeItem = (id) => {
              const filteredItems = itemArr.filter(item => item.id !== id);
              setItemArr(filteredItems);
            //   sendBackData(filteredItems)
            };
            const updateItemTitle = (id, title) => {
              
              setItemArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, title :title } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));

     sendBackArray(reorderedItems)
    return reorderedItems;
  });
            
            };  
            
            const updateItemSubTitle = (id, subtitle) => {
              
              setItemArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, subtitle :subtitle } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));

     sendBackArray(reorderedItems)
    return reorderedItems;
  });
            
            };
              const updateItemHideImage = (id, hideImage) => {
              
              setItemArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, hideImage :hideImage } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));

     sendBackArray(reorderedItems)
    return reorderedItems;
  });
            
            };
           
        
          const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
      const [draggedIndex, setDraggedIndex] = useState('');
      const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
      
      const handleDragStart = (e, index) => {
        
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData("dragIndex", index);
        
      };
      
      const handleDrop = (e, dropIndex) => {
        const dragIndex = e.dataTransfer.getData("dragIndex");
        if (dragIndex === dropIndex) return;
      
        const updatedItems = [...itemArr];
        const [draggedItem] = updatedItems.splice(dragIndex, 1);
        updatedItems.splice(dropIndex, 0, draggedItem);
      
        const reorderedItems = updatedItems.map((item, index) => ({
          ...item,
          id: item.id,
        }));
        setItemArr(reorderedItems);
        sendBackArray(reorderedItems)
        setDraggedIndex('');
        setHoveredDropZone(null); // Reset hovered drop zone
      };
      
      const handleDragOver = (e, index) => {
        e.preventDefault();
         // Set the hovered drop zone
      };
      
      const handleDragEnd = () => {
        setDraggedIndex('');
        setHoveredDropZone(null); // Clear hovered drop zone
      };
        const duplicateItem = (obj) => {
  
  setItemArr((prev) => {
    const updatedItems = [...prev];
    const index = updatedItems.findIndex(item => item.id === obj?.id);

    if (index !== -1) {
      const originalItem = updatedItems[index];
      const duplicatedItem = {
        ...originalItem,
        id: Date.now(), // generate new unique ID
        myKey: originalItem.id + generateTimestamp(), // or use a better unique label
      };
  // console.log(originalItem)
      // Insert the duplicated item right after the original
      updatedItems.splice(index + 1, 0, duplicatedItem);

      const reorderedItems = updatedItems.map((item, idx) => ({
        ...item,
        no: idx + 1, // optional: re-number
      }));

    

    
    // this code is for reloading status for settings component
   
    sendBackArray(reorderedItems)
      return reorderedItems;
    }
    return prev;
  });
}; 
const deleteItem = (obj) => {
  setItemArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.filter(item => item.id !== obj?.id);

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      no: index + 1,
    }));

     sendBackArray(reorderedItems)
    return reorderedItems;
  });
};
        
  return (
    <div style={{ padding:"10px",}}>
      {itemArr?.map((item,index) => (<div>
        <div
          className="drop-zone"
          onDragOver={(e) => {
            handleDragOver(e, index) // index+1 for add  below item
          }}
          onDrop={(e) =>{ handleDrop(e, index);setSelectedItemIndex(null);setHoveredDropZone(null);}}
        
          style={{
            height: hoveredDropZone === index ?'50px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(144, 202, 249,0.1) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(144, 202, 249,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"20px":"0px",display:"flex",justifyContent:"center",
           visibility:hoveredDropZone === index ?"visible":"hidden",fontSize:"14px"
          }}
        ><div style={{paddingTop:"15px",}}>Drop Item Here</div></div>
        <div className="imageItemHover" key={item.id} style={{  opacity: selectedItemIndex!==index ?'1':"0.3", position: "relative",display: "flex", gap: "5px",justifyContent:"space-between"}}
        
        draggable  
onDragOver={(e) => { if(selectedItemIndex!==index){
  setHoveredDropZone(index);
    handleDragOver(e, index)
  }
  }}
  onDrop={(e) => {setSelectedItemIndex(null);setHoveredDropZone(null);}}

             onDragStart={(e) =>{
               handleDragStart(e, index);
              setDraggedIndex(item.id);setSelectedItemIndex(index);
             }}
            
              // onDragEnd={handleDragEnd}
onDragEnd={(e) =>{setSelectedItemIndex(null);setHoveredDropZone(null);}}
        
        
        ><div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{marginTop:"18px",height:"30px",cursor:"move",
        // opacity:selectedItemIndex!==index ?'':"0", 
      borderRadius:"50%",position:"relative",zIndex:"99999",
        alignContent:"center",textAlign:"center",padding:"5px"}}>
          <GripVertical color="rgba(144, 202, 249,1)" size={22} />
          </div>  <div  style={{
            // opacity:selectedItemIndex!==index ?'':"0"
            }}>
             <ImageWithFallback src={item.image} widthOuter={"80px"} fireOpenEdit ={()=>{setImageObject(item);setEditImage(true);setItemTitle(item?.title);setItemSubTitle(item?.subtitle)}} iconSize={28} setOpenFullImg={()=>{}}/> 
          </div>
         
          <div style={{position: "relative",marginTop:"18px",
            // opacity:selectedItemIndex!==index ?'':"0"
            }}>
             <div  className="ButtonWithEllipsis" style={{
             width: `80px`, fontSize:`15px`,fontWeight:"600",textAlign: "left" ,
            
      }}>{item?.title}</div>
       <div  className="ButtonWithEllipsis" style={{
             width: `80px`, fontSize:`11px`,fontWeight:"500",textAlign: "left" ,
            
      }}>{item?.subtitle}</div>
              </div>
              <div  className="hoverItemImages" onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
  }} style={{
    // opacity:selectedItemIndex!==index ?'':"0",
    border:"3px solid rgba(144, 202, 249,1) ",width:"20px",height:"20px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer",marginTop:"18px"}} color="rgba(144, 202, 249,1)" size={13}>
           <EllipsisVertical size={22}  color="rgba(144, 202, 249,1)"/>
           
           
           <div className="showImagesSettings" style={{ border:"3px solid rgba(144, 202, 249,1) ",borderRadius:"20px",paddingTop:"25px"}}>
            <div style={{position:"absolute",top:"-40px",left:"35px"}}><ImageWithFallback src={item.image} widthOuter={"70px"} fireOpenEdit ={()=>{setImageObject(item);setEditImage(true);setItemTitle(item?.title);setItemSubTitle(item?.subtitle)}}  iconSize={28} setOpenFullImg={()=>{}}/></div> 
           <div className=" showImagesSettingsItem"
      onClick={()=>{}}
      > 
      <div className="ElementSettingsItem"
      onClick={()=>{}}
      ><Edit size={18}  color="#444" />
    </div><div className="" style={{ fontSize:`13px`,fontWeight:"600",paddingTop:"5px"}}
      onClick={()=>{setImageObject(item);setEditImage(true);setItemTitle(item?.title);setItemSubTitle(item?.subtitle)}}
      >Edit Item</div>
    </div>      <div className=" showImagesSettingsItem"
      onClick={()=>{}}
      > 
      <div className="ElementSettingsItem"
      onClick={()=>{}}
      ><CopyPlus size={18}  color="#444" />
    </div><div className="" style={{ fontSize:`13px`,fontWeight:"600",paddingTop:"5px"}}
      onClick={()=>{duplicateItem(item)}}
      >Duplicate</div>
    </div>  <div className=" showImagesSettingsItem"
      onClick={()=>{}}
      > 
      <div className="ElementSettingsItem"
      onClick={()=>{}}
      ><Trash2 size={18}  color="#444" />
    </div><div className="" style={{ fontSize:`13px`,fontWeight:"600",paddingTop:"5px"}}
      onClick={()=>{deleteItem(item) }}
      >Delete</div>
    </div>
    </div></div>
        </div>
        {editImage?
        <div>
        <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99999,cursor:"pointer",}} onClick={()=>{setEditImage(false);setImageObject({})}} className="appDesignPopUpOpacity"> </div>
        <div   className="AreYouSurePopUpTwo" style={{borderRadius: '0px'}}>
            

        <h2 align="center" > Edit <span className="coloredTextV1" >Item </span> </h2>
      
 
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"80%",overflowX:"hidden"}}>
<div align="center" >
    <ImageWithFallback src={imageObject?.image} widthOuter={"320px"} fireOpenEdit ={()=>{}}  iconSize={44}  setOpenFullImg={()=>{setOpenFullImg(true)}}/> </div>
{/* hide : <Toggle state={itemHideImage} toggleState={(state)=>{setItemHideImage(state) ;updateItemHideImage(imageObject?.id, state);}} /> */}
<div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px"}}>
    <h3 style={{textAlign:"left"}} >Edit Title</h3>
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"20px",padding:"10px"}} placeholder={`Add Quiz Name`} type="text"
  rows={1} name="courseTitle" value={itemTitle} onChange={(e)=>{setItemTitle(e.target.value);}} />
 </div>
<div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px"}}>
    <h3 style={{textAlign:"left"}} >Edit Subtitle</h3>
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"20px",padding:"10px"}} placeholder={`Add Quiz Name`} type="text"
  rows={1} name="courseTitle"  value={itemSubTitle} onChange={(e)=>{setItemSubTitle(e.target.value)}} />
 </div>

</div>
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   zIndex:"99",
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setEditImage(false);setImageObject({})}}   className=" CoursesPreviewTopBtn"  type="submit"
 > Cancel </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{updateItemTitle(imageObject?.id, itemTitle);
    updateItemSubTitle(imageObject?.id, itemSubTitle);setEditImage(false);setImageObject({})}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>
</div>
{openFullImg?<div>
            <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:9999999,cursor:"pointer",background:"#000000"}} onClick={()=>{setOpenFullImg(false);}} className="appDesignPopUpOpacity"> 
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:99999999}} onClick={()=>{setOpenFullImg(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
 <div className="AreYouSurePopUpTwo " style={{overflowY:"auto",height:"99%",overflowX:"hidden"}}>
 
      
      <img
        src={imageObject?.image}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
        style={{
          borderRadius: "10px",
          position: "relative",
         
          width: "100%",zIndex:999999,
          
          
          marginTop: "0px",border:"3px solid rgba(144, 202, 249,1)",
        //   display: isLoaded && !hasError ? "block" : "none",
        }}
      /></div></div></div>:""} 
</div> 


</div>:""}

        </div>

      ))}
    </div>
  );
};

export default ImagesUI;